import React, { FunctionComponent } from "react";
import { PostSnippet } from "../../types";
import { PageHeader } from "../pageHeader";
import { PostGrid } from "../postCard";

export interface TagCollection {
  tag: string;
  relatedPosts: PostSnippet[];
}

export const TagCollection: FunctionComponent<TagCollection> = ({
  relatedPosts,
  tag,
}) => (
  <>
    <PageHeader title={`#${tag}`} />
    <div className="px-gutter-sm pb-14 md:px-gutter">
      <PostGrid posts={relatedPosts} />
    </div>
  </>
);
